import React, { Component } from 'react';
import { moveDefaultCollectionFieldsToEndAndSort } from '../../../common/utils/api_utils';
export default class CurrentUserParamRow extends Component {
  static propTypes = {};

  state = {
    paramKey: this.props.paramRow.key,
    paramValue: this.props.paramRow.value,
  };

  onKeyChange = (e) => {
    this.setState({
      ...this.state,
      paramKey: e.target.value,
    });

    this.props.paramRow.key = e.target.value;
    this.props.createNewParamRowForUser(this.props.paramRow);
  };

  onValueChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      ...this.state,
      paramValue: value,
    });
    this.props.paramRow.value = value;
    this.props.createNewParamRowForUser(this.props.paramRow);
  };

  userFieldOptions = () => {
    const { userCollection } = this.props;
    if (!userCollection) {
      return 'No Login Plugin Installed';
    }
    const { fields, utilities, constants } = userCollection;
    return (
      <select
        name="paramValue"
        className="form-control form-control-sm custom-select-sm"
        onChange={this.onValueChange}
        value={this.state.paramValue}
      >
        <option value="">-Select One-</option>
        <optgroup label="Fields">
          {fields.length > 0 &&
            moveDefaultCollectionFieldsToEndAndSort(fields, true).map((field) => (
              <option
                key={field.fieldName}
                value={JSON.stringify({ name: field.fieldName, type: 'collection-field' })}
              >
                {field.fieldTitle.en}
              </option>
            ))}
        </optgroup>
        <optgroup label="Derived Fields">
          {utilities.length > 0 &&
            utilities.map((field) => (
              <option
                key={field.name}
                value={JSON.stringify({ name: field.name, type: 'derived-field' })}
              >
                {field.name}
              </option>
            ))}
        </optgroup>
        <optgroup label="Collection Constant">
          {constants.length > 0 &&
            constants.map((field) => (
              <option
                key={field.name}
                value={JSON.stringify({ name: field.name, type: 'collection-constant' })}
              >
                {field.name}
              </option>
            ))}
        </optgroup>
      </select>
    );
  };

  render() {
    return (
      <tr>
        <td>
          <input
            type="text"
            name="paramKey"
            value={this.state.paramKey}
            className="form-control form-control-sm"
            onChange={this.onKeyChange}
            placeholder="Key"
          />
        </td>
        <td>{this.userFieldOptions()}</td>
      </tr>
    );
  }
}
